import React, { useEffect, useState } from "react";
import { getFullVersion } from "util/Version";
import { SystemStore } from "stores/system/SystemStore";
import useProductName from "brand-customization/useProductName";
import useSystemDetails from "hooks/useSystemDetails";
const StandardFooter = () => {
  const productName = useProductName();
  const [jvm, setJvm] = useState();
  const system = useSystemDetails();
  useEffect(() => {
    let mounted = true;
    SystemStore.jvm().then((jvmInfo) => {
      if (mounted) {
        setJvm(jvmInfo);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);
  return !(system && jvm) ? /* @__PURE__ */ React.createElement(React.Fragment, null, productName, " ", getFullVersion()) : /* @__PURE__ */ React.createElement(React.Fragment, null, productName, " ", system.version, " on ", system.hostname, " (", jvm.info, ")");
};
export default StandardFooter;
